import { type TrackedEvent } from '../../../utils/events/trackEvent'

export const getNavigationActionEventDataV3 = (
  href: string | undefined,
  route: string | undefined
): TrackedEvent => ({
  id: 'navV3.navigation.action',
  description: 'User clicked to navigate',
  data: { href, route },
})
